import { put , call, takeEvery} from 'redux-saga/effects';
import {setApplicationConfig, setRejectionReasons,setAgreementRejectionReasons,  setStandardGoUrls} from '../actions/AppActions';
import ApprovalService from "../services/ApprovalService";
import {setAvailableLocale, setLocaleStatus} from '../actions/LocaleActions';

export function* loadConfigSaga(){

    yield takeEvery('LOAD_CONFIG', function* (action){
        yield call(loadConfigActionSaga);
    })  
}

export function* loadConfigActionSaga(){    
    try{        
        const res = yield call(ApprovalService.getConfig);
        let hostName = window.location.hostname;
        if(res && res.data && res.data.services.length){
            if(hostName.indexOf('helpx.adobe.com') >=0){
                yield put(setApplicationConfig(res.data.services[1]));
            }else{
                yield put(setApplicationConfig(res.data.services[0]));
            }
            yield put(setRejectionReasons(res.data.rejectReasons));
            yield put(setAgreementRejectionReasons(res.data.rejectAgreementReasons));
            yield put(setStandardGoUrls(res.data.goUrls));
        }
    }catch(error){
        console.log('Error while loading config');
    }
    
}

export function* loadLangConfigSaga(){

    yield takeEvery('LOAD_LANG_CONFIG', function* (action){
        yield call(loadLangConfigActionSaga);
    })  
}

export function* loadLangConfigActionSaga(){    
    try{        
        const res = yield call(ApprovalService.getConfig);   
        
        if(res && res.data && res.data.services){
            if ((window.location.href.indexOf("stage") > -1) || (window.location.href.indexOf("localhost") > -1)) {
                yield put(setAvailableLocale(res.data.services[0].locales));
                yield put(setLocaleStatus(true));
            }
            else{
                yield put(setAvailableLocale(res.data.services[1].locales));
                yield put(setLocaleStatus(true));
            }
        }
    }catch(error){
        console.log('Error while loading config');
    }
    
}

